// website base URL
export const BASE_URL = 'https://guitar2tabs.com';
export const COMPANY_URL = 'https://klangio.com';
export const AI2NOTES_URL = 'https://ai2notes.com';

export const S2N_BASE_URL = 'https://sing2notes.com';
export const P2N_BASE_URL = 'https://piano2notes.com';
export const MS_BASE_URL = 'https://melodyscanner.com';

if (global.window && !localStorage.getItem('AB')) {
  localStorage.setItem('AB', Math.random() > 0.5 ? 'A' : 'B');
}

export const ECARDS_AMOUNTS: any = [
  {
    amount: 3,
    price: '$4.99',
    color: 'green',
    productId: 745293,
    // discount: 0.2,
  },
  {
    amount: 10,
    price: '$9.99',
    color: 'yellow',
    productId: 745327,
    // discount: 0.2,
  },
  {
    amount: 50,
    price: '$24.99',
    color: 'blue',
    productId: 745328,
    // discount: 0.2,
  },
  {
    amount: 100,
    price: '$49.99',
    color: 'pink',
    productId: 745329,
    // discount: 0.2,
  },
];
